import React, { Component } from 'react'
import { Tab, Nav } from 'react-bootstrap'
import Attacking from './tabs/Attacking'
import { ReactComponent as IconAttacking } from '../../../../assets/svg/dashboard/player/icn-attacking.svg'
import Skills from './tabs/Skills'
import { ReactComponent as IconSkills } from '../../../../assets/svg/dashboard/player/icn-skill.svg'
import Movement from './tabs/Movement'
import { ReactComponent as IconMovement } from '../../../../assets/svg/dashboard/player/icn-movement.svg'
import Power from './tabs/Power'
import { ReactComponent as IconPower } from '../../../../assets/svg/dashboard/player/icn-power.svg'
import Mental from './tabs/Mental'
import { ReactComponent as IconMental } from '../../../../assets/svg/dashboard/player/icn-mental.svg'
import Defending from './tabs/Defending'
import { ReactComponent as IconDefending } from '../../../../assets/svg/dashboard/player/icn-defence.svg'
import GoalKeeping from './tabs/GoalKeeping'
import { ReactComponent as IconGoalkeeping } from '../../../../assets/svg/dashboard/player/icn-goalkeeping.svg'
import Specialities from './tabs/Specialities'
import { ReactComponent as IconSpecialities } from '../../../../assets/svg/dashboard/player/icn-specialities.svg'
import SimpleScrollbar from '../../../ui/custom_scrollbars/SimpleScrollbar'
import Tooltip from '../../../ui/tooltips/Tooltip'

class EvaluationTabs extends Component {
    constructor(props) {
        super(props);

        this.state = {
            key: "attacking"
        };
    }

    render() {
        return (
            <div className="right-side-content player-evaluation-tabs">
                <Tab.Container
                    defaultActiveKey={this.state.key}
                    onSelect={key => this.setState({ key })}
                >
                    <Tab.Content>
                        {this.wrapTabContent(this.state.key)}
                    </Tab.Content>
                    <Nav variant="pills">
                        {this.renderNavItem('attacking')}
                        {this.renderNavItem('skills')}
                        {this.renderNavItem('movement')}
                        {this.renderNavItem('power')}
                        {this.renderNavItem('mental')}
                        {this.renderNavItem('defending')}
                        {this.renderNavItem('goalKeeping')}
                        {this.renderNavItem('specialities')}
                    </Nav>
                </Tab.Container>
            </div>
        )
    }

    renderNavItem = (key) => {
        const EvIcon = this.icons[key];

        return (
            <Tooltip text={key}>
                <Nav.Item>
                    <Nav.Link eventKey={key}>
                        <EvIcon />
                    </Nav.Link>
                </Nav.Item>
            </Tooltip>
        )
    }

    icons = {
        attacking: () => <IconAttacking />,
        skills: () => <IconSkills />,
        movement: () => <IconMovement />,
        power: () => <IconPower />,
        mental: () => <IconMental />,
        defending: () => <IconDefending />,
        goalKeeping: () => <IconGoalkeeping />,
        specialities: () => <IconSpecialities />,
    }

    renderTabContent(key) {
        switch (key) {
            case 'attacking':
                return <Attacking insertedImage={this.props.insertedImage} />
            case 'skills':
                // return <Skills />
                return <Attacking insertedImage={this.props.insertedImage} />
            case 'movement':
                // return <Movement />
                return <Attacking insertedImage={this.props.insertedImage} />
            case 'power':
                // return <Power />
                return <Attacking insertedImage={this.props.insertedImage} />
            case 'mental':
                // return <Mental />
                return <Attacking insertedImage={this.props.insertedImage} />
            case 'defending':
                // return <Defending />
                return <Attacking insertedImage={this.props.insertedImage} />
            case 'goalKeeping':
                // return <GoalKeeping />
                return <Attacking insertedImage={this.props.insertedImage} />
            case 'specialities':
                // return <Specialities />
                return <Attacking insertedImage={this.props.insertedImage} />
            default:
                return null;
        }
    }

    wrapTabContent(key) {
        return (
            <Tab.Pane eventKey={key}>
                <SimpleScrollbar
                    maxHeight="calc(100vh - 189px)"
                // minHeight={200}
                >
                    {this.renderTabContent(key)}
                </SimpleScrollbar>
            </Tab.Pane>
        )
    }
}

export default EvaluationTabs